import * as logMessageTypes from '../../consts/app/logMessageTypes';
import queryParameters from '../../consts/route/queryParameters';
import log from '../../services/logger/log';
import server from '../../services/server/server';
import storageService from '../../services/storage/storageService';
import urlUtils from '../../utils/urlUtils';
import * as marketNames from './marketNames';

const MARKET_MAPPING = {
    uat: marketNames.UAT,
};

export const getMarketByCountryCode = async () => {
    if (process.env.NODE_ENV !== 'production') return;

    const isGrDisabled = storageService.getGeoRestrictionFromLocalStorage();

    if (isGrDisabled) return;

    const [gr] = urlUtils.getDataFromUrl(queryParameters.GEO_RESTRICTION);

    if (gr === 'false') {
        storageService.setDisableGeoRestrictionToLocalStorage();
        return;
    }

    const countryCheckUri = 'DATA_COUNTRY_CODE';
    const countryCheckUrl = process.env.PUBLIC_URL + '/' + countryCheckUri;

    try {
        const countryCodeResponse = (await server.get(countryCheckUrl))?.data;
        const countryCode = countryCodeResponse ? countryCodeResponse.toLowerCase() : undefined;

        if (countryCode) {
            const marketName = MARKET_MAPPING[countryCode];

            if (marketName) return marketName;

            return countryCode;
        }
    } catch (e) {
        log.error(`getMarketByCountryCode: error: ${e}`, logMessageTypes.INTERNAL);
    }

    return null;
};
